<template>
  <component :is="tag" :class="styleClass" :style="style">
    <slot />
  </component>
</template>

<script>
import Sizes from '../../../Constants/Sizes'
export default {
  name: 'Typography',
  props: {
    strong: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'md',
      validator: value => Object.values(Sizes).includes(value)
    },
    tag: {
      type: String,
      default: 'p'
    },
    color: {
      type: String,
      default: '#242424'
    },
    subtitle: {
      type: Boolean,
      default: false
    },
    isDarkBackground: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    style () {
      return {
        color: this.color
      }
    },
    styleClass () {
      const partialClass = { 'rhg-text-strong': this.strong, 'rhg-text-normal': !this.strong, 'rhg-subtitle-light': this.subtitle && !this.isDarkBackground, 'rhg-subtitle-dark': this.subtitle && this.isDarkBackground }
      partialClass[`rhg-text-${this.size}`] = true
      return partialClass
    }
  }
}
</script>

<style lang="scss">
.rhg-text-strong {
  font-weight: 700;
}

.rhg-text-normal {
  font-weight: 400;
}

.rhg-subtitle-light {
  opacity: 0.5;
}

.rhg-subtitle-dark {
  opacity: 0.7;
}

.rhg-text-4xl {
  font-size: 36px;
  line-height: 44px;
}

.rhg-text-3xl {
  font-size: 24px;
  line-height: 30px;
}

.rhg-text-2xl {
  font-size: 24px;
  line-height: 30px;
}

.rhg-text-xl {
  font-size: 20px;
  line-height: 26px;
}

.rhg-text-lg {
  font-size: 20px;
  line-height: 26px;
}

.rhg-text-md {
  font-size: 16px;
  line-height: 22px;
}

.rhg-text-sm {
  font-size: 14px;
  line-height: 18px;
}

.rhg-text-xs {
  font-size: 12px;
  line-height: 16px;
}

@media (min-width: 992px) {
  .rhg-text-4xl {
    font-size: 56px;
    line-height: 72px;
  }

  .rhg-text-3xl {
    font-size: 48px;
    line-height: 58px;
  }

  .rhg-text-2xl {
    font-size: 36px;
    line-height: 44px;
  }

  .rhg-text-xl {
    font-size: 24px;
    line-height: 30px;
  }
}

.rhg-isDarkBackground {
  background-color: #29344d;
}

.rhg-display-one {
  font-size: 3.6rem;
  line-height: 7.2rem;
  font-weight: 400;
  color: #242424;
}

.rhg-display-two {
  font-size: 2.4rem;
  line-height: 5.8rem;
  font-weight: 700;
  color: #242424;
}

.rhg-title-one {
  font-size: 2.4rem;
  line-height: 4.4rem;
  font-weight: 400;
  color: #242424;
}

.rhg-title-two {
  font-size: 2rem;
  line-height: 3rem;
  font-weight: 400;
  color: #242424;
}

.rhg-subtitle {
  font-size: 2rem;
  line-height: 2.6rem;
  font-weight: 400;
  color: rgba(#242424, 0.5);
}

.rhg-body-text {
  font-size: 1.6rem;
  line-height: 2.2rem;
  font-weight: 400;
  color: #242424;
}

.rhg-caption-one {
  font-size: 1.4rem;
  line-height: 1.8rem;
  font-weight: 400;
  color: #242424;
}

.rhg-caption-two {
  font-size: 1.2rem;
  line-height: 1.6rem;
  font-weight: 400;
  color: #242424;
}

.rhg-link-text {
  font-size: 1.4rem;
  line-height: 2rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #242424;
}

.rhg-small-CTA-text {
  font-size: 1.2rem;
  line-height: 2rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #242424;
}

.rhg--strong {
  font-weight: 700;
}

.rhg-title--white {
  color: #ffffff;
}

.rhg-subtitle--white {
  color: rgba(#ffffff, 0.5);
}

@media (min-width: 992px) {
  .rhg-display-one {
    font-size: 5.6rem;
  }

  .rhg-display-two {
    font-size: 4.8rem;
  }

  .rhg-title-one {
    font-size: 3.6rem;
  }

  .rhg-title-two {
    font-size: 2.4rem;
  }
}
</style>
